import type {
  HTMLAttributes,
  InputHTMLAttributes,
  LabelHTMLAttributes,
  SelectHTMLAttributes,
} from "react";
import { cn } from "../../lib/cn";

// Formular-Grundbausteine. Bewusst native Elemente (<input>, <select>): volle
// Tastatur- und Screenreader-Unterstützung ohne zusätzliche Bibliothek.

const fieldClasses =
  "h-10 w-full rounded-md border border-line bg-card px-3 text-sm text-ink placeholder:text-ink-muted aria-invalid:border-error-fill";

export function Input({ className, ...props }: InputHTMLAttributes<HTMLInputElement>) {
  return <input className={cn(fieldClasses, className)} {...props} />;
}

export function Select({ className, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return <select className={cn(fieldClasses, className)} {...props} />;
}

export function Label({ className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  // htmlFor kommt über ...props vom Aufrufer.
  return <label className={cn("text-sm font-medium text-ink", className)} {...props} />;
}

export function FieldHint({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("text-xs text-ink-muted", className)} {...props} />;
}

export function FieldError({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p role="alert" className={cn("text-xs text-error-fg", className)} {...props} />;
}
